import { defineRule } from "vee-validate";
import useUnformattingPhoneNumber from "./use/useUnformattingPhoneNumber";

defineRule("required", (value: string, [name]: string[]) => {
  if (!value || !value.length) {
    return name ? `${name} 입력하세요.` : "";
  }
  return true;
});

defineRule(
  "dependenciesRequired",
  (value: string, [name, dependentValue]: string[]) => {
    if (dependentValue && !value) {
      return name ? `${name} 입력하세요.` : "";
    }
    return true;
  }
);

defineRule("email", (value: string) => {
  const isValid =
    /^([0-9a-zA-Z_.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/.test(value);
  if (!isValid) {
    return "올바른 이메일 형식을 입력하세요.";
  }
  return true;
});

defineRule(
  "password",
  (value: string, [regexParts, errorMessage]: string[]) => {
    const regEx = new RegExp(regexParts.toString());
    const isValid = regEx.test(value.toString());
    if (value && !isValid) {
      return errorMessage;
    }
    return true;
  }
);

// defineRule("password", (value: string) => {
//   const isValid = /^(?=.*[A-Za-z])(?=.*[0-9]).{6,12}$/.test(value);
//   if (!isValid) {
//     return "영문, 숫자를 포함해 6~12자를 입력하세요.";
//   }
//   return true;
// });

defineRule("passwordConfirm", (value: string, [password]: string[]) => {
  if (value !== password) {
    return "비밀번호가 일치하지 않습니다.";
  }
  return true;
});

defineRule("currentPassword", (value: string) => {
  const isValid = /^(?=.*[A-Za-z])(?=.*[0-9]).{6,12}$/.test(value);
  if (!isValid) {
    return "영문, 숫자를 포함해 6~12자를 입력하세요.";
  }
  return true;
});

defineRule("newPassword", (value: string, [password]: string[]) => {
  if (password && value === password) {
    return "현재 비밀번호와 같은 비밀번호로 변경할 수 없습니다.";
  }
  return true;
});

defineRule("phone", (value: string) => {
  const unformattedNumber = useUnformattingPhoneNumber(value);

  // 마스킹된 번호 허용: 숫자 + * 만 포함, 총 길이는 11자
  const isMasked = /^[0-9*]{11}$/.test(unformattedNumber);

  // 일반 번호: 숫자만 허용, 총 길이는 11자
  const isPlainValid = /^[0-9]{11}$/.test(unformattedNumber);

  if (!isMasked && !isPlainValid) {
    return "휴대폰 번호 11자리를 정확히 입력하세요.";
  }

  return true;
});

defineRule("newPhone", (value: string, [phone]: string[]) => {
  if (useUnformattingPhoneNumber(value) === phone) {
    return "현재 전화번호와 같은 전화번호로 변경할 수 없습니다.";
  }
  return true;
});

defineRule("newAddress", (value: string, [address]: string[]) => {
  if (value === address) {
    return "현재 주소와 같은 주소로 변경할 수 없습니다.";
  }
  return true;
});

defineRule("min", (value: string, [num]: string[]) => {
  if (value.length < Number(num)) {
    return `${num}자리 이상 입력하세요.`;
  }
  return true;
});

defineRule("max", (value: string, [num]: string[]) => {
  if (value.length > Number(num)) {
    return `${num}자리 이하 입력하세요.`;
  }
  return true;
});

defineRule("length", (value: string, [name, num]: string[]) => {
  if (value.length !== Number(num)) {
    return `${name} ${num}자리를 입력하세요.`;
  }
  return true;
});

defineRule("expiryDate", (value: string, [num]: string[]) => {
  value = value.replace("/", "");
  if (!value || !value.length) {
    return `유효기간을 입력하세요.`;
  } else if (value.length !== Number(num)) {
    return "유효기간을 정확히 입력하세요.";
  }
  return true;
});

defineRule("businessNumber", (value: string, [num]: string[]) => {
  value = value.replace(/-/g, "");
  if (!value || !value.length) {
    return `사업자번호를 입력하세요.`;
  } else if (value.length !== Number(num)) {
    return `사업자번호 ${num}자리를 정확히 입력하세요.`;
  }
  return true;
});

defineRule(
  "checkDuplication",
  (value: string, [checkedDuplication]: string[]) => {
    if (!value || checkedDuplication === "false") {
      return "아이디 중복확인을 해주세요.";
    }
    return true;
  }
);
